//
// [アドイン] エスケープキーで閉じちゃうぞ、の巻
//
// hooks/useEscapeClose.js
//
import { useEffect } from 'react';

export function useEscapeClose(onClose) {
  useEffect(() => {
    const handleKey = (e) => {
      if (e.key === 'Escape') {
        onClose();
      }
    };
    window.addEventListener('keydown', handleKey);
    return () => {
      window.removeEventListener('keydown', handleKey);
    };
  }, [onClose]);
}
